
import { Base } from '../base-component';

import './table-context.component.scss';

export class TableContext extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() { }

	bindEvents() { }

}



// WEBPACK FOOTER //
// ./components/table-context/table-context.component.ts